import React from "react";
import { Globe } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";

const LanguageToggle = () => {
  const { lang, toggle, t } = useI18n();
  const next = lang === "en" ? t.lang.switch_to_ar : t.lang.switch_to_en;

  return (
    <button
      type="button"
      onClick={toggle}
      data-testid="language-toggle-button"
      aria-label="Toggle language"
      className="group inline-flex items-center gap-2 rounded-full border border-[rgba(212,175,55,0.25)] bg-[rgba(212,175,55,0.04)] px-3.5 py-1.5 text-xs tracking-[0.16em] uppercase text-[var(--gold-bright)] transition-all hover:border-[rgba(212,175,55,0.55)] hover:bg-[rgba(212,175,55,0.1)] hover:shadow-[0_0_24px_-6px_rgba(212,175,55,0.5)]"
    >
      <Globe size={14} className="opacity-80 group-hover:opacity-100" />
      <span className="font-medium">{next}</span>
    </button>
  );
};

export default LanguageToggle;
